import styles from "./TourListCard.module.css";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { MdShare } from "react-icons/md";
import TourShareModal from './../tour-share-modal/TourShareModal';
import { useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import { removeTourSelector } from "../../hooks/store/setters";
import { useAppStore } from "../../hooks/store/useAppStore";
import { deleteTour } from "../../services/TourService";
import { setAlertMessageSelector } from "../../hooks/store/setters";
import { setLoaderSelector } from "../../hooks/store/setters";
import { setConfirmModelSelector } from "../../hooks/store/setters";
import { confirmModelSelector } from "../../hooks/store/getters";
import { userSelector } from "../../hooks/store/getters";

const TourListCard = ({ tour, onDelete=()=>{} }) => {
    
    const [showShareModal, setShowShareModal] = useState(false);
    const handleShareModalClose = () => setShowShareModal(false);
    const handleShowShareModal = () => setShowShareModal(true);
    const removeTour = useAppStore(removeTourSelector);
    const history = useHistory();
    const setAlertMessage = useAppStore(setAlertMessageSelector);
    const setLoader = useAppStore(setLoaderSelector);
    const setConfirmModel = useAppStore(setConfirmModelSelector);
    const confirmModel = useAppStore(confirmModelSelector);
    const user = useAppStore(userSelector);
    
    
    const tourPoster = tour.info.tourPoster.url || tour.info.tourPoster.file;
   
    const deletConfirmModel = () => {

        const payload = { 
            ...confirmModel, 
            title: "Delete Tour", 
            text: "Are you sure want to delete the tour?", 
            show: true, 
            cancelButtonText: "Cancel",
            successButtonText: "Delete",
            successCallback: deleteTourHandler 
        };

        setConfirmModel(payload);
    }

    const deleteTourHandler = async () => {
        console.log('in delete handler');
        setLoader("Loading...")
        setConfirmModel({ show:false });
        try {
            await deleteTour(tour.id);
            removeTour(tour.id);
        } catch (error) {
            setAlertMessage("Error while deleting tour");
        }
        onDelete();
        setLoader("")
        setAlertMessage("Tour deleted successfully");
        
    }
    
    const viewTour = () => {
        history.push(`/view-tour/${tour.id}`);
    }
    
    const viewTourVR = () => {
        const hashedID = functionfunc(`${tour.id}`);
        window.location.replace(`https://myhometownproject.com/vr/tour.html?` + hashedID);
    }

    const functionfunc = (string) => {
        var hash = 0;
        var ch, x;
        if (string.length == 0) return hash;
        for (x = 0; x <string.length; x++) {
            ch = string.charCodeAt(x);
            hash = ((hash <<5) - hash) + ch;
            hash = hash & hash;
        }
        hash = Math.abs(hash);
        hash = hash.toString();
        hash = hash.substring(0,6);
        return hash;
    }

    return (
        <Card className={styles.tourListCard}>
            <div className={styles.tourPoster}>
                <Card.Img lazy="true" src={tourPoster} alt="Card image" />
                <div className={styles.tourPosterTint}></div>
            </div>
            
            <div className={styles.tourShareIcon} onClick={handleShowShareModal}>
                <MdShare />
            </div>
            
            <TourShareModal 
                show={showShareModal} 
                handleClose={handleShareModalClose} 
                tourId={tour.id}
            />
            
            <Card.Body className={styles.tourListCardBody}>
                <Card.Title>
                    <h2>{tour.info.tourName}</h2>
                    <b>Pin: {functionfunc(`${tour.id}`)}</b>
                </Card.Title>
                <Card.Text className="py-4">
                    <span className={styles.lineClamp}>
                    {tour.info.tourDescription}
                    </span>
                </Card.Text>
                <div className={styles.tourListCardFooter}>
                    <Button variant="info" 
                        className={styles.tourListCardFooterButton}
                        onClick={viewTour}
                    >
                        View
                    </Button>
                    <Button variant="info" 
                        className={styles.tourListCardFooterButton}
                        onClick={viewTourVR}
                    >
                        View VR
                    </Button>
                   
                    { (user.uid === tour.createdBy || user.uid === tour.createdBy.uid || user.userRole === "ADMIN") &&  
                        <>   
                        <Button variant="warning" 
                            className={styles.tourListCardFooterButton}
                            as={Link}
                            to={`/edit-tour/${tour.id}/tour-info/`}
                        >
                            Edit
                        </Button>
                        <Button variant="danger" className={styles.tourListCardFooterButton} onClick={deletConfirmModel}>
                            Delete
                        </Button>
                        </>
                     }             
                </div>
            </Card.Body>
        </Card>
    )
}

export default TourListCard;
